<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>